import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import AcedSelect, {
	SelectOptions,
} from "../../../components/essentials/input/select/AcedSelect";

interface Step1BasicInfoProps {
	subjectOptions: SelectOptions;
}

const Step1BasicInfo: React.FC<Step1BasicInfoProps> = ({ subjectOptions }) => {
	const { t } = useTranslation();
	const { control } = useFormContext();

	return (
		<div className="step-content">
			<div className="container">
				<div className="row-group">
					<AcedSelect
						label={t("createJob.objectLabel")}
						control={control}
						options={subjectOptions}
						placeholder={t("createJob.placeholder.select")}
						name="subject"
						rules={{ required: t("createJob.validation.required") }}
						className="w-100"
					/>
				</div>
			</div>
		</div>
	);
};

export default Step1BasicInfo;
